import { render, staticRenderFns } from "./PriviVIP.vue?vue&type=template&id=4b6eab40&scoped=true"
import script from "./PriviVIP.vue?vue&type=script&lang=js"
export * from "./PriviVIP.vue?vue&type=script&lang=js"
import style0 from "./PriviVIP.vue?vue&type=style&index=0&id=4b6eab40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6eab40",
  null
  
)

export default component.exports